import { useTranslation } from 'react-i18next';
import { requestResetLinkSchema } from './ForgotPassword.schema';
import RequestResetLinkForm from './RequestResetLinkForm';
import RequestSentSection from './RequestSentSection';
import useForgotPasswordSubmit from './useForgotPasswordSubmit';
import FormWithProvider from '@/components/forms/form/Form';
import {
  PublicFormSubtitle,
  PublicFormTitle,
} from '@/pages/_layouts/publicLayout/publicForm.styles';

const RequestResetLinkSection = () => {
  const {
    handleSubmitForgotPassword,
    clearErrors,
    errorMessage,
    isRequestSent,
    isSubmitting,
  } = useForgotPasswordSubmit();

  const { t } = useTranslation();

  if (isRequestSent) {
    return <RequestSentSection />;
  }

  return (
    <FormWithProvider
      horizontal
      onSubmit={handleSubmitForgotPassword}
      resolver={requestResetLinkSchema()}
      defaultValues={{ email: '' }}
    >
      <PublicFormTitle data-testid="forgot-password-title">
        {t('pageForgotPassword.requestTitle')}
      </PublicFormTitle>
      <PublicFormSubtitle data-testid="forgot-password-subtitle">
        {t('pageForgotPassword.requestSubtitle')}
      </PublicFormSubtitle>
      <RequestResetLinkForm
        clearErrors={clearErrors}
        errorMessage={errorMessage}
        isSubmitting={isSubmitting}
      />
    </FormWithProvider>
  );
};

export default RequestResetLinkSection;
